module.exports = __webpack_public_path__ + "img/6.e7209444.jpg";